AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.SlackFilesController extends AccessController
    constructor: (@scope, @transitions, @service, @q, @http) ->
        super('slack_files', @http)

        # Turn on mfResizable
        @scope.fullpage = true
        @scope.title = 'Manage Your Slack Files'

        @scope.token = null
        @scope.actuallyAll = false
        @scope.files = []
        @scope.displayedCollection = []
        @scope.users = []
        @scope.parseInt = parseInt
        @scope.findUserById = @findUserById
        @scope.deleteFile = @deleteFile
        @scope.deleteAll = @deleteAll

        @loadScopeData @service.getToken(), 'token'
            .then () =>

                @scope.$watch 'token', (token) =>
                    return if not token
                    @service.saveToken token
                        .then () =>
                            @getFiles()

        @getFiles()

    getFiles: () =>
        promises = []

        promises.push @loadScopeData @service.getUsers(), 'users'
        promises.push @loadScopeData @service.getFiles(), 'files'

        @q.all promises
            .then () =>
                for file in @scope.files
                    file.person = @findUserById(file.user).profile.real_name
                angular.element(@window).trigger 'resize'

    findUserById: (id) =>
        for user in @scope.users
            return user if user.id is id
        { name: 'Unknown' }

    deleteFile: (file) =>
        @service.deleteFile file.id
        .then (response) =>
            if response.data.status.type is 'success' and response.data.data.ok?
                @scope.files.splice @scope.files.indexOf(file), 1

    deleteAll: () =>
        collection = if @scope.actuallyAll then @scope.files else @scope.displayedCollection
        for file in collection
            @deleteFile(file)
